export const endpoints = {
  attachments: 'api/v1/attachment',
  connection: 'api/v1/connection',
  dashboards: 'api/v1/dashboard',
  diggingPermit: 'api/v1/diggingpermit',
  leasehold: 'api/v1/leasehold',
  taplan: 'api/v1/taplan',
  search: 'api/v1/search',
  mapserver: 'api/v1/mapserver',
  license: 'api/v1/license',
  codedValueDomain: 'api/v1/codedValueDomain',
  vtDomain: 'api/v1/vtDomain',
  vtRecoveryTypes: 'api/v1/vTRecoveryType',
  vtLeaseholdTypes: 'api/v1/vTLeaseholdType',
  settings: 'api/v1/setting',
  proxy: 'api/proxy',
  user: 'api/v1/user',
  tenant: 'api/v1/tenant',
  DPVersionNumber: 'api/v1/version'
};
